import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Toast from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import VueGoogleMaps from '@fawmi/vue-google-maps'
import pinia from './plugins/pinia'

createApp(App)
    .use(store)
    .use(router)
    .use(vuetify)
    .use(Toast)
    .use(pinia)
    .use(VueGoogleMaps,{
        load: {
            key: process.env.VUE_APP_MAPS_API_KEY,
            libraries: 'places',
        },
    }
).mount('#app')
